export class PolyfillManager {
  constructor() {
    this.initializePolyfills();
  }

  initializePolyfills() {
    this.scrollToPolyfill();
    this.animationFramePolyfill();
    // call other polyfills methods here
    // this.anotherPolyfill();
  }

  scrollToPolyfill() {
    if (!window.scrollTo) {
      function customScrollTo({ top = 0, left = 0 }) {
        if (typeof top !== 'number' || top < 0) {
          throw new Error('CallError: The "top" parameter must be a non-negative number.');
        }
        if (typeof left !== 'number' || left < 0) {
          throw new Error('CallError: The "left" parameter must be a non-negative number.');
        }
        const scrollElement = this ? this : document.documentElement;
        scrollElement.scrollLeft = left;
        scrollElement.scrollTop = top;
      }

      window.scrollTo = customScrollTo.bind(document.documentElement || document.body);
      Element.prototype.scrollTo = customScrollTo;
    }
  }

  animationFramePolyfill() {
    function requestAnimationDoesNotExists() {
      console.error('Your browser is not supported requestAnimationFrame');
    }

    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame =
        window.webkitRequestAnimationFrame || requestAnimationDoesNotExists;
      window.cancelAnimationFrame =
        window.webkitCancelRequestAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        requestAnimationDoesNotExists;
    }
  }

  // Add other polyfill methods here
}
